<template>
  <DialogFactory :value="value">
    <DialogTitleHeader text="Nowy kurs" @click="emitCloseEvent"></DialogTitleHeader>
    <v-item-group v-if="userHasServiceRole" v-model="selectedCourseType" class="course-type__container" mandatory>
      <CourseTypeCard text="Nowy kurs" icon="mdi-car" value="course" />
      <CourseTypeCard text="Nowy serwis" icon="mdi-wrench" value="service" />
    </v-item-group>
    <v-card-text class="pt-4 pb-0 px-6">
      <BaseTypography variant="body-1">Wybierz dla jakiej firmy kolejowej tworzysz nowy kurs.</BaseTypography>
      <v-form ref="form" lazy-validation>
        <RailwayCompanyInputFactory v-model="selectedRailwayCompany"></RailwayCompanyInputFactory>
      </v-form>
    </v-card-text>
    <DialogSaveButton text="Potwierdź" @click="acceptNewCourseConfig"></DialogSaveButton>
  </DialogFactory>
</template>

<script>
import { mapGetters } from 'vuex';
import DialogFactory from '@/component/Dialog/dialog-factory';
import DialogTitleHeader from '@/component/Dialog/dialog-title-header';
import DialogSaveButton from '@/component/Dialog/dialog-save-button';
import BaseTypography from '@/component/Base/base-typography';
import { TAXI_COURSE_CREATE_ROUTE, SERVICE_CREATE_ROUTE } from '@/core/router/route-names';
import CourseTypeCard from './services/course-type-card';
import RailwayCompanyInputFactory from './railway-company-input/railway-company-input-factory';

export default {
  name: 'SelectCourseTypeModal',
  components: {
    DialogFactory,
    DialogTitleHeader,
    CourseTypeCard,
    BaseTypography,
    RailwayCompanyInputFactory,
    DialogSaveButton,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedRailwayCompany: null,
      selectedCourseType: 'course',
    };
  },
  created() {
    if (this.isCompany) {
      this.selectedRailwayCompany = this.user.company;
    }
  },
  computed: {
    ...mapGetters(['user', 'isTransportCompany', 'isCompany', 'userHasServiceRole']),
  },
  methods: {
    emitCloseEvent() {
      this.$emit('close');
      this.$refs.form.reset();
    },
    acceptNewCourseConfig() {
      if (this.$refs.form ? this.$refs.form.validate() : true) {
        if (this.selectedCourseType === 'course') {
          this.$store.dispatch('courseCreation/setCompany', this.selectedRailwayCompany);
          this.$router.push({ name: TAXI_COURSE_CREATE_ROUTE });
        } else {
          this.$store.dispatch('service/setCompany', this.selectedRailwayCompany);
          this.$router.push({ name: SERVICE_CREATE_ROUTE });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.course-type__container {
  display: flex;
  gap: 10px;
  padding: 16px 24px;
}
</style>
